<loading-spinner *ngIf="isLoading"></loading-spinner>

<div id="page--edit-form">
  <!--<h1>isLoading? [{{isLoading}}]</h1>-->
  <form #editReferralForm="ngForm">
    <mat-drawer-container class="sidenav-container" [hasBackdrop]="false">
      <!--<div *ngIf="isLoading">
        <loading-spinner></loading-spinner>
      </div>-->
      <loading-spinner *ngIf="isLoading"></loading-spinner>
      <mat-drawer #Drawer class="edit-panel" position="end" style="width:600px !important">
        <div *ngIf="!isLoading">
          <div class="edit-panel__form">
            <div class="edit-panel__form-inner">
              <div class="edit-panel__close" (click)="hideFormDetails()">
                <i class="material-icons">highlight_off</i>
              </div>
              <div class="ng-star-inserted">
                <h2 class="heading">Edit form details</h2>
                <ul class="grid grid--row-1">
                  <li>
                    <label>Name</label>
                    <mat-form-field>
                      <div class="validation__holder">
                        <input matInput name="formName" [(ngModel)]="referralForm!.name" maxlength="500" placeholder="Name" required />
                        <div class="validation"></div>
                      </div>
                    </mat-form-field>
                  </li>
                  <li>
                    <label>Description</label>
                    <mat-form-field>
                      <div class="validation__holder">
                        <input matInput name="formDescription" [(ngModel)]="referralForm!.description" maxlength="500" placeholder="Description" required />
                        <div class="validation"></div>
                      </div>
                    </mat-form-field>
                  </li>
                  <li class="edit-panel__item edit--group-panel">
                    <label>Type</label>
                    <mat-form-field>
                      <mat-select [(value)]="referralForm!.referralFormTypeId">
                        <mat-option *ngFor="let referralFormType of referralFormTypes" [value]="referralFormType.referralFormTypeId">
                          {{referralFormType.description}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>

                  <li>
                    <label>Threshold Score</label>
                    <mat-form-field>
                      <div class="validation__holder">
                        <input matInput name="thresholdScore" [(ngModel)]="referralForm!.thresholdScore" placeholder="Threshold Score" required />
                        <div class="validation"></div>
                      </div>
                    </mat-form-field>
                  </li>
                  </ul>

                  <ul class="grid grid--row-3">
                    <li>
                      <label>Form is active?</label>
                      <!--<input type="checkbox" name="active" [(ngModel)]="referralForm!.active" />-->
                      <mat-checkbox [(ngModel)]="referralForm!.active" name="active">Active</mat-checkbox>
                    </li>
                  </ul>

                  <div class="button__row">
                    <div></div>
                    <button class="button--box blue save" (click)="save()" [disabled]="isSaveDisabled()">Save</button>
                  </div>
              </div>
            </div>
            <!--USE SIDE PANEL SETUP QUESTION GROUPS PAGE-->
          </div>
        </div>
      </mat-drawer>

      <mat-drawer-content>
        <div class="content__holder">
          <h2 class="heading">Admin: Edit "{{referralForm!.name}}"  - Version {{referralForm!.version}}</h2>
          <div class="button__row floating">
            <a class="button--box blue back" href="/forms">Back</a>
            <div style="display:flex; flex-direction:row;">
              <a class="button--box blue edit" (click)="showFormDetails()">Edit form details</a>&nbsp;
              <button class="button--box blue save" (click)="save()" [disabled]="isSaveDisabled()">Save</button>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading">
          <div class="content__holder">

            <ul class="grid grid--row-2">
              <li>
                <h3 class="heading">Form Question Groups</h3>
                <ol cdkDropList id="rfqg" class="form-edit__group-list sortable ui-sortable" cdkDropListData="referralFormQuestionGroups"
                    cdkDropListConnectedTo="qg" (cdkDropListDropped)="drop($event)">
                  <li class="form-edit__group-item" *ngFor="let referralFormQuestionGroup of referralFormQuestionGroups" cdkDrag>
                    <h5 class="form-edit__group-title">
                      <span class="form-edit__group-title-text">{{referralFormQuestionGroup.name}}</span>
                      <div class="form-edit__group-buttons">
                        <i class="material-icons form-edit__expand-group-icon"
                           (click)="referralFormQuestionGroup.questionGroupId != referralFormQuestionGroup.questionGroupId ? true : false"
                           [ngClass]="referralFormQuestionGroup.questionGroupId ? '' : 'active'">expand_more</i>
                      </div>
                    </h5>
                    <ol class="form-edit__question-list unsortable" [ngClass]="referralFormQuestionGroup.questionGroupId ? '' : 'active'">
                      <li class="form-edit__question-item unsortable" *ngFor="let questionGroupQuestion of referralFormQuestionGroup.questionGroupQuestions">
                        <span class="form-edit__question-item-text">{{questionGroupQuestion.question.name}}</span>
                        <span class="form-edit__question-item-type">Text</span>
                        <i class="material-icons form-edit__expand-icon">expand_more</i>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li>
                <h3 class="heading">All Question Groups</h3>
                <ul cdkDropList id="qg" class="form-edit__group-list sortable" cdkDropListData="questionGroups"
                    cdkDropListConnectedTo="rfqg" (cdkDropListDropped)="drop($event)">
                  <li class="form-edit__group-item" *ngFor="let questionGroup of questionGroups" cdkDrag>
                    <h5 class="form-edit__group-title">
                      <span class="form-edit__group-title-text">{{questionGroup.name}}</span>
                      <div class="form-edit__group-buttons">
                        <i class="material-icons form-edit__expand-group-icon"
                           (click)="questionGroup.questionGroupId != questionGroup.questionGroupId ? true : false"
                           [ngClass]="questionGroup.questionGroupId ? '' : 'active'">expand_more</i>
                      </div>
                    </h5>
                    <ol class="form-edit__question-list unsortable" [ngClass]="questionGroup.questionGroupId ? '' : 'active'">
                      <li class="form-edit__question-item unsortable" *ngFor="let questionGroupQuestion of questionGroup.questionGroupQuestions">
                        <span class="form-edit__question-item-text">{{questionGroupQuestion.question.name}}</span>
                        <span class="form-edit__question-item-type">Text</span>
                        <i class="material-icons form-edit__expand-icon">expand_more</i>
                      </li>
                    </ol>
                  </li>
                </ul>
              </li>
            </ul>

          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </form>
</div>
